export enum ServiceContractRythm {
  JAEHRLICH = 'JAEHRLICH',
  QUARTAL = 'QUARTAL',
  MONATLICH = 'MONATLICH',
  HALBJAEHRLICH = 'HALBJAEHRLICH',
  ZWEI_JAHRE = 'ZWEI_JAHRE',
  DREI_JAHRE = 'DREI_JAHRE',
  FUENF_JAHRE = 'FUENF_JAHRE',
}
